module.exports = __webpack_public_path__ + "img/AB-resller-icon.8526ebf5.png";